var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBudgetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 50,
    viewBox: "0 0 38 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E3C2F0",
    d: "M24 4.5C24 6.986 21.761 9 19 9c-2.762 0-5-2.014-5-4.5C14 2.015 16.238 0 19 0c2.761 0 5 2.015 5 4.5",
    transform: "translate(-293 -164) translate(9 148) translate(284 16)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9494ED",
    d: "M37.014 30.01H35.04c-.437-6.45-4.743-11.86-10.657-14.009-.109.42-.493.731-.954.731h-9.443c-.46 0-.845-.311-.953-.732-1.674.61-3.221 1.478-4.589 2.56l-1.153-1.134c-.385-.378-1.01-.378-1.396 0-.384.379-.384.993 0 1.37l1.09 1.07C4.95 21.919 3.47 24.5 2.778 27.383H0v7.42h2.779c.806 3.356 2.682 6.305 5.255 8.482l-1.58 4.077L13.511 50l1.274-3.289c1.258.305 2.57.469 3.924.469 1.857 0 3.64-.309 5.302-.868L25.441 50l7.055-2.64-1.985-5.124c2.64-2.7 4.333-6.3 4.547-10.287h1.956c.545 0 .986-.434.986-.97 0-.535-.441-.968-.986-.968M8.559 28.189c-.982 0-1.778-.783-1.778-1.748 0-.966.796-1.749 1.778-1.749.984 0 1.78.783 1.78 1.75 0 .964-.796 1.747-1.78 1.747",
    transform: "translate(-293 -164) translate(9 148) translate(284 16)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudgetIcon);
export default __webpack_public_path__ + "static/media/budgetIcon.3b0877605c599303a157d319c0015e1e.svg";
export { ForwardRef as ReactComponent };